import axiosInstance from "../../../axios";
import config from "../../../config";
import { usePersistedStore } from "../../persisted-store";

export const createNotificationsSlice = (set, get) => ({
    notifications: {
        loading: false,
        data: []
    },
    getNotification: async () => {
        const token = usePersistedStore.getState().business.currentBusiness.token;
        set(state => ({ notifications: { ...state.notifications, loading: true } }));
        try {
            const resp = await axiosInstance({
                method: 'get',
                baseURL: config.apiUrls(),
                url: `/v1/user/notification`,
                headers: { token }
            });
            set(state => ({ notifications: { loading: false, data: resp.data.Notifications } }));
        } catch (error) {
            set(state => ({ notifications: { ...state.notifications, loading: false } }));
        }
    }
});
